<template lang="html">
    <div class="cloud">
        <div @click="toCloudServer" class="banner-img">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/productService/cloud/cloud-bg.png" alt=""> -->
        </div>
        <!-- 介绍 -->
        <div class="product">
            <div class="container">
                <img src="https://static.qyjmed.com/webSite/productService/aboutApp/shuangyinhao.png" alt="">
                <p class="wow zoomInDown">平台创新性利用互联网开拓信息渠道，颠覆传统的服务运营模式。通过整合医院、经销商、供应商等终端的产品和专业性服务，形成长期战略合作关系，共同建立了一个联盟性的行业生态链。真正实现海量行业信息资源的高效整合，灵活满足不同客的户差异化需求并实现集约化效益。</p>
                <img src="https://static.qyjmed.com/webSite/productService/aboutApp/shuangyinhao1.png" alt="">
            </div>
        </div>
        <!-- 两大服务 -->
        <div class="second">
            <div class="container">
                <h2>两个服务</h2>
                <div data-wow-delay="1s" class="wow bounceInLeft second-box">
                    <img src="https://static.qyjmed.com/webSite/productService/cloud/server1.png" alt="">
                    <p class="second-text">一键报修，医院快速报修</p>
                    <p>云端报修，精准快速</p>
                </div>
                <div data-wow-delay="1s" class="wow bounceInRight second-box">
                    <img src="https://static.qyjmed.com/webSite/productService/cloud/server2.png" alt="">
                    <p class="second-text">整合数千家供应商，一键报价</p>
                    <p>配件库云端管理，与医院无缝对接</p>
                </div>
            </div>
        </div>
        <!-- 云服务平台 -->
        <div class="cloud-server" id="cloudServer">
            <div class="container">
                <h2>云服务平台服务功能</h2>
                <img src="https://static.qyjmed.com/webSite/productService/cloud/round.png" alt="">
                <img src="https://static.qyjmed.com/webSite/productService/cloud/round1.png" alt="">
                <img src="https://static.qyjmed.com/webSite/productService/cloud/round2.png" alt="">
                <img src="https://static.qyjmed.com/webSite/productService/cloud/round3.png" alt="">
                <img src="https://static.qyjmed.com/webSite/productService/cloud/round4.png" alt="">
                <div class="server-box server-box1">
                    <p><i></i></p>
                    <p>3000家维修服务商信息筛选推送</p>
                </div>
                <div class="server-box server-box2">
                    <p><i></i></p>
                    <p>30家质量检测机构提供全面质控、检测支持</p>
                </div>
                <div class="server-box server-box3">
                    <p><i></i></p>
                    <p>12000名工程师在线及时响应</p>
                </div>
                <div class="server-box server-box4">
                    <p><i></i></p>
                    <p>7X24小时客服全方位服务承诺</p>
                </div>
                <div class="server-box server-box5">
                    <p><i></i></p>
                    <p>报修信息同步上传数据需求随时满足</p>
                </div>
                <div class="server-box server-box6">
                    <p><i></i></p>
                    <p>服务信息、维修进度及时反馈、随时查询</p>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'app',
  methods:{
      toCloudServer:()=>{
          document.querySelector("#cloudServer").scrollIntoView(true);
      },
  },
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    .cloud{
        .banner-img{
            margin-top: $highlight-height;
            cursor: pointer;
            background: url('https://static.qyjmed.com/webSite/productService/cloud/cloud-bg.png') center;
            height: 562px;
        }
        // 介绍
        .product{
            img{
                width: 60px;
                height: 46px;
                display: inline-block;
                &:first-child{
                    vertical-align: top;
                    margin-top: 50px;
                }
                &:last-child{
                    vertical-align: bottom;
                    margin-bottom: 40px;
                }
            }
            p{
                display: inline-block;
                width: 1000px;
                margin:80px 40px;
                font-size: 20px;
                color:#606060;
                line-height: 40px;
            }
        }
        // 两大服务
        .second{
            .container{
                h2{
                    text-align: center;
                    color: #1B212B;
                    font-size: 40px;
                    font-weight: 400;
                    margin-bottom: 80px;
                }
                .second-box{
                    width: 50%;
                    display: inline-block;
                    text-align: center;
                    p{
                        font-size: 29px;
                        color: #000000;
                        &.second-text{
                            margin:58px 0 46px;
                        }
                        &:last-child{
                            font-size: 18px;
                            margin-bottom: 100px;
                        }
                    }
                }
            }
        }
        .cloud-server{
            height: 950px;
            background: url('https://static.qyjmed.com/webSite/productService/cloud/server-bg.png');
            .container{
                text-align: center;
                h2{
                    font-size: 40px;
                    color: #1B212B;
                    padding:112px 0 102px;
                }
                img{
                    position: absolute;
                    margin-left: 285px;
                    animation: rotating 20s linear infinite;
                    &:nth-child(2){
                        margin-left: 420px;
                        margin-top: 80px;
                    }
                    &:nth-child(3){
                        margin-left: 260px;
                    }
                    &:nth-child(4){
                        margin-left: 360px;
                        margin-top: 50px;
                    }
                    &:nth-child(5){
                        margin-left: 480px;
                        margin-top: 50px;
                    }
                    &:nth-child(6){
                        animation: 0;
                        margin-left: 380px;
                        margin-top: 20px;
                        animation: pulse 5s linear infinite;
                    }
                }
                div{
                    position: relative;
                    width: 50%;
                    display: inline-block;
                    p{
                        width: 160px;
                        font-size: 16px;
                        color: #000;
                        line-height: 30px;
                        text-align: left;
                        i{
                            width: 20px;
                            height: 6px;
                            background-color: #0F83F7;
                            display: block;
                            margin-bottom: 6px;
                        }
                    }
                    &.server-box1{
                        p{
                            margin-left: 150px;
                        }
                    }
                    &.server-box2{
                        p{
                            margin-left: 250px;
                        }
                    }
                    &.server-box3{
                        margin-top: 130px;
                    }
                    &.server-box4{
                        p{
                            margin-left: 430px;
                        }
                    }
                    &.server-box5{
                        margin-top: 130px;
                        p{
                            margin-left: 150px;
                        }
                    }
                    &.server-box6{
                        p{
                            margin-left: 250px;
                        }
                    }
                }
            }
        }
    }
    @keyframes rotating{
from{transform:rotate(0)}
to{transform:rotate(360deg)}
}
</style>
